// extracted by mini-css-extract-plugin
export default {"submitBtn":"process-state-form_submitBtn__O1qyi"};